/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { AnalyticsResultFormatterMessage } from "../../../messages/analytics-result-formatter.message";
const lookup = require("country-code-lookup");

export const triggerRegionStats = (lifeCycle: any) => {
  const message = lifeCycle?.fsm?.message as AnalyticsResultFormatterMessage;
  const template = message?.template?.layout[0]?.colProps;
  const found = template?.find((o: any) => o.key === "region-stats");
  if (found?.compProps?.rowValues) {
    found.compProps.rowValues = message?.raw?.regionStats?.map(
      (stat: any, index: number) => {
        return {
          country: lookup.byIso(stat?.country)?.country,
          totalProvisionalPolicies: stat?.totalProvisionalPolicies?.formatted,
          totalActualPolicies: stat?.totalActualPolicies?.formatted,
          actualPoliciesSalesValue: stat?.actualPoliciesSalesValue?.formatted,
        };
      }
    );
  }
  return true;
};
